export default "__VITE_ASSET__9b1d5645__"